import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { VppApplicationsStoreActions, VppApplicationsStoreSelectors } from '../vpp-applications';

@Injectable({ providedIn: 'root' })
export class VppApplicationsResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(VppApplicationsStoreSelectors.selectAllVppApplications).pipe(
      tap((vppApplications) => {
        // Only load the vpp applications if they aren't already loaded
        if (vppApplications.length < 1) {
          this.store.dispatch(VppApplicationsStoreActions.VppApplicationsResolverActions.vppApplicationsRequested());
        }
      }),
      map(() => true),
      first()
    );
  }
}
